/**
 * Rejects search keywords that are empty or contain only special characters /
 * whitespace (no letters or digits in any script).
 */
export const isMeaningfulSearchKeyword = (value = "") => {
  const trimmed = String(value || "").trim()
  if (!trimmed) return false
  return /[\p{L}\p{N}]/u.test(trimmed)
}
